import React, { useMemo } from 'react';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { ExtendedUseFormReturn } from '../../../hooks/providers/useFormHooks';
import { ISupplierModel } from '../../Supplier/types';
import { FormTypes, MoveMoneyTypes, UpdateVendorFormProps } from '../interfaces';
import { buildPayload } from '../services';

interface IUpdateVendorFooterProps {
  formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>,
  supplierId?: string,
  formType: FormTypes,
  moveType: MoveMoneyTypes,
  isEditMode: boolean,
  isVendorUpdateMandatory: boolean,
  onVendorDelete: () => void,
  onVendorSubmit: (payload: ISupplierModel) => void,
  isLoading?: boolean,
  isLoadingDelete?: boolean,
  customSubmitTitle?: string,
}

export const UpdateVendorFooter = (props: IUpdateVendorFooterProps) => {
  const { formMethods, isLoadingDelete, isLoading, onVendorDelete, onVendorSubmit, formType, moveType, isVendorUpdateMandatory, isEditMode, supplierId = '', customSubmitTitle } = props;
  const isAnyErrorsExist = useMemo(() => Object.keys(formMethods.formState.errors).length > 0, [formMethods]);
  const shouldShowDeleteButton = useMemo(() => (supplierId && !isVendorUpdateMandatory && !isEditMode), [supplierId, isVendorUpdateMandatory, isEditMode]);

  const handleSubmit = () => {
    const formPayload = buildPayload(formMethods, supplierId, formType, moveType);
    onVendorSubmit(formPayload);
  };

  const handleVendorDelete = () => {
    onVendorDelete();
  };

  return (
    <div className='sticky z-50 left-0 bottom-0 flex items-center justify-center border-t gap-[24px] border-bw03 py-[24px] bg-bw01'>
      {shouldShowDeleteButton && <LiliButton isLoading={isLoadingDelete} disabled={isLoading} onClick={handleVendorDelete} className={shouldShowDeleteButton ? 'w-[264px]' : 'w-[375px]'} id='' type={LiliButtonType.DESTRUCTIVE} title='Delete' />}
      <LiliButton isLoading={isLoading} disabled={!formMethods.formState.isValid || isAnyErrorsExist || isLoading} onClick={handleSubmit} className={shouldShowDeleteButton ? 'w-[264px]' : 'w-[375px]'} id='submit' type={LiliButtonType.PRIMARY} title={customSubmitTitle || 'Continue'} />
    </div>
  );
};
